import React from "react";
import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-kingdom text-paper relative overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-24 pb-14 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-8">
              <img
                src="/assets/logo/huddleup-logo-gold.png"
                alt="HuddleUp"
                className="h-10 w-10 object-contain"
              />
              <span
                className="text-paper text-[13px] font-medium"
                style={{ letterSpacing: "0.32em" }}
              >
                HUDDLEUP
              </span>
            </div>
            <p className="font-display text-2xl leading-snug text-paper max-w-md">
              Your commercial arm in Saudi Arabia.
            </p>
            <p className="mt-6 text-sm text-warm/80 leading-relaxed max-w-md">
              Helping international companies prove demand, stay represented,
              and build the right operating layer in the Kingdom.
            </p>
          </div>

          <div className="md:col-span-2">
            <div className="eyebrow mb-5">Services</div>
            <ul className="space-y-3">
              {[
                ["Commercial Proof", "/services#commercial-proof"],
                ["Commercial Arm", "/services#commercial-arm"],
                ["Commercial Build", "/services#commercial-build"],
              ].map(([label, to]) => (
                <li key={label}>
                  <Link
                    to={to}
                    data-testid={`footer-service-${label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-warm text-sm hover:text-gold transition-colors duration-500"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="eyebrow mb-5">Company</div>
            <ul className="space-y-3">
              {[
                ["About", "/about"],
                ["Market Notes", "/market-notes"],
                ["Find Your First Move", "/diagnostic"],
              ].map(([label, to]) => (
                <li key={label}>
                  <Link
                    to={to}
                    data-testid={`footer-company-${label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-warm text-sm hover:text-gold transition-colors duration-500"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow mb-5">Social</div>
            <a
              data-testid="footer-linkedin"
              href="https://www.linkedin.com/company/huddleup-sa/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 text-warm text-sm hover:text-gold transition-colors duration-500"
            >
              <Linkedin size={16} />
              <span>LinkedIn</span>
            </a>
          </div>
        </div>

        <div className="hairline my-14"></div>

        <p className="text-xs text-warm/60 leading-relaxed max-w-3xl">
          HuddleUp supports commercial strategy, opportunity navigation, provider
          coordination, and workstream management. Formal submissions,
          contracting, licensing, and regulated activities remain subject to the
          client’s approved structure, providers, and applicable requirements.
        </p>

        <p className="text-[11px] text-warm/40 mt-6 tracking-[0.2em] uppercase">
          © {new Date().getFullYear()} HuddleUp.sa
        </p>
      </div>
    </footer>
  );
}
